import { database } from "../firebase";
import { ref, onValue } from "firebase/database";

/**
 * Subscribes to a user's scan list, sorts by timestamp desc,
 * keeps a localStorage cache for instant rendering on mount.
 *
 * @param {string} userPath - sanitized user email path
 * @param {function} onUpdate - called with the sorted scans array
 * @returns {function} unsubscribe cleanup function
 */
export function subscribeToScans(userPath, onUpdate) {
  const scanRef = ref(database, `data/scans/${userPath}`);
  const cacheKey = `scans_${userPath}`;

  // Seed state from cache for instant render
  const cached = localStorage.getItem(cacheKey);
  if (cached) {
    try {
      onUpdate(JSON.parse(cached));
    } catch {
      localStorage.removeItem(cacheKey);
    }
  }

  const unsubscribe = onValue(scanRef, (snapshot) => {
    if (!snapshot.exists()) {
      onUpdate([]);
      localStorage.removeItem(cacheKey);
      return;
    }

    const entries = Object.entries(snapshot.val()).map(([key, value]) => ({
      ...value,
      key,
    }));

    const sorted = entries.toSorted((a, b) => {
      const ta = Number(a.createTimestamp ?? a.timestamp ?? 0);
      const tb = Number(b.createTimestamp ?? b.timestamp ?? 0);
      return tb - ta;
    });

    onUpdate(sorted);

    try {
      localStorage.setItem(cacheKey, JSON.stringify(sorted));
    } catch { }
  });

  return () => unsubscribe();
}
